import { AsyncModule } from 'vuex-async-mutations';

import details from '@/store/base.details';
import crud from '@/store/base.crud';
import paginated from '@/store/base.items.paginated';
import table from '@/store/modules/tables';
import { InstallerCapacity, Project, HocoTarget } from '@/types';

import columns from '@/apps/office/components/table/planning/targets/columns';
import presets from '@/apps/office/components/table/planning/targets/presets';
import renderers from '@/apps/office/components/table/shared/items/renderers';

export default {
  namespaced: true,

  async: true,

  modules: {
    details: details<Project>('/housingCooperativeTarget'),
    items: paginated<Project>(id => ({
      endpoint: `/housingCooperativeTarget`,
      params: { housingCooperativeId: id! },
    })),
    crud: crud<Project>('/housingCooperativeTarget'),
    settings: table('planning/hocotargets', presets, columns, renderers),
    dictionaries: {
      namespaced: true,

      actions: {
        ['fetch']() {
          this.dispatch('dictionaries/housingCooperatives/fetch');
        },
      },
    },
  },

  getters: {},

  actionsAsync: {
    fill: {
      handler(context, value: InstallerCapacity) {
        return this.$axios.post('/installerCapacity/fill', value);
      },
    },
  },
} as AsyncModule<any, any>;
